module.exports = __webpack_public_path__ + "static/media/workPvcCeilings10.43b4d5b8.jpg";